import { render, staticRenderFns } from "./_AddressPhone.vue?vue&type=template&id=fc37e3d0"
import script from "./_AddressPhone.vue?vue&type=script&lang=js"
export * from "./_AddressPhone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports